import { useState } from 'react';
import { useParams } from 'react-router';

import Header from '../Header';
import { RightSidebarWrapper } from '../RightSidebar/RightSidebarWrapper';

import { type ReportType, StageFeedbackView } from './StageFeedbackView';

import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

const InvestmentsDirectIdFeedback = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    throw new Error('Missing deal opportunity ID');
  }

  const [reportType, setReportType] = useState<ReportType>('rsm');

  return (
    <>
      <Header />
      <RightSidebarWrapper>
        <div className="min-w-0 space-y-2.5 px-5 pt-5 pb-16.5 md:pl-14">
          <h2 className="text-lg font-semibold">Choose your Stage</h2>
          <RadioGroup
            className="grid grid-cols-2 gap-x-6"
            onValueChange={value => {
              setReportType(value as ReportType);
            }}
            value={reportType}
          >
            <label
              className="flex items-center gap-x-2"
              htmlFor="rsm-display"
            >
              <span className="text-sm">RSM</span>
              <RadioGroupItem
                id="rsm-display"
                value="rsm"
              />
            </label>
            <label
              className="flex items-center gap-x-2"
              htmlFor="icb-display"
            >
              <span className="text-sm">ICB</span>
              <RadioGroupItem
                id="icb-display"
                value="icb"
              />
            </label>
          </RadioGroup>

          <StageFeedbackView
            opportunityId={id}
            reportType={reportType}
          />
        </div>
      </RightSidebarWrapper>
    </>
  );
};

export default InvestmentsDirectIdFeedback;
